import { PaymentTypeStaff } from '@insurance/api/requests'
import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = { isLegalEntity?: boolean; isCreditType?: boolean } & SelectProps<
  PaymentTypeStaff | PaymentExtendType
>

export enum PaymentExtendType {
  ONLINE_PAYMENT = 'online_payment'
}

export const SelectPaymentType = ({
  isLegalEntity,
  isCreditType,
  ...props
}: Props) => {
  const { t } = useTranslation()

  return (
    <Select
      style={{ width: 150 }}
      options={Object.values({
        ...PaymentTypeStaff
        // ...PaymentExtendType
      })
        .filter(
          (value) =>
            (isLegalEntity || value !== PaymentTypeStaff.BANK_TRANSFER) &&
            (isCreditType
              ? value === PaymentTypeStaff.CREDIT
              : value !== PaymentTypeStaff.CREDIT)
        )
        .map((value) => ({
          label: t(value),
          value
        }))}
      {...props}
    />
  )
}
